export enum ERegions {
  Moscow = 1,
  MoscowRegion = 4593,
  MiMO = -1,
  Spb = 2,
  SpbRegion = 4588,
  SPiLO = -2,
  Ufa = 176245,
  Bashkortostan = 4560,
  NizhniyNovgorod = 4885,
  NizhniyNovgorodRegion = 4596,
  RostovNaDony = 4959,
  RostovRegion = 4606,
  Samara = 4966,
  SamaraRegion = 4608,
  Kazan = 4777,
  Tatarstan = 4618,
  Krasnodar = 4820,
  KrasnodarRegion = 4584,
  Vologda = 4708,
  VologdaRegion = 4566,
  Ekaterinburg = 4743,
  SverdlovskRegion = 4612,
  Kaluga = 4780,
  KalugaRegion = 4576,
  KrasnoyarskRegion = 4585,
  VoronezhRegion = 4567,
}
